// frontend/src/lib/superAdmin.js
import { supabase } from "./supabaseClient";

const LS_OVERRIDE_KEY = "aifine_entitlement_override_v1";

function parseEmailList(raw) {
  return String(raw || "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function getSuperAdminEmailAllowlist() {
  // CRA exposes only REACT_APP_* env vars to the frontend bundle
  const raw = process.env.REACT_APP_SUPER_ADMIN_EMAILS || "";
  return parseEmailList(raw);
}

export function isEmailSuperAdmin(email) {
  const allow = getSuperAdminEmailAllowlist();
  if (!allow.length) return false;
  const e = String(email || "").trim().toLowerCase();
  if (!e) return false;
  return allow.includes(e);
}

export async function getCurrentSessionUserEmail() {
  try {
    const { data } = await supabase.auth.getSession();
    const email = data?.session?.user?.email || null;
    return email ? String(email) : null;
  } catch {
    return null;
  }
}

export async function isCurrentUserSuperAdmin() {
  const email = await getCurrentSessionUserEmail();
  return isEmailSuperAdmin(email);
}

/**
 * Entitlement override (local dev only; super-admin gated by UI)
 */
export function readEntitlementOverride() {
  try {
    const raw = localStorage.getItem(LS_OVERRIDE_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    return obj && typeof obj === "object" ? obj : null;
  } catch {
    return null;
  }
}

export function writeEntitlementOverride(next) {
  try {
    if (!next) {
      localStorage.removeItem(LS_OVERRIDE_KEY);
      return true;
    }
    localStorage.setItem(LS_OVERRIDE_KEY, JSON.stringify(next));
    return true;
  } catch {
    return false;
  }
}

export function clearEntitlementOverride() {
  try {
    localStorage.removeItem(LS_OVERRIDE_KEY);
  } catch {
    // ignore
  }
}